var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-checkbox",
        {
          attrs: { "true-label": 1, "false-label": 0, disabled: _vm.disabled },
          model: {
            value: _vm.allowDownload_,
            callback: function ($$v) {
              _vm.allowDownload_ = $$v
            },
            expression: "allowDownload_",
          },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("pc_kng_permissionset_lbl_candownload" /** 允许下载 */)
              ) +
              "\n    "
          ),
          _vm.allowDownload_
            ? _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "pc_kng_upload_label_candownload_desc" /** （控制PC端、App端是否允许下载） */
                    )
                  )
                ),
              ])
            : _vm._e(),
        ]
      ),
      _vm.allowDownload_
        ? _c(
            "div",
            [
              _c(
                "yxt-radio-group",
                {
                  staticClass: "ml24",
                  attrs: { direction: "row", disabled: _vm.disabled },
                  model: {
                    value: _vm.permissionType,
                    callback: function ($$v) {
                      _vm.permissionType = $$v
                    },
                    expression: "permissionType",
                  },
                },
                [
                  _c("yxt-radio", { attrs: { label: 0 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_lbl_classification_down" /** 跟随分类中的“允许下载课件”权限 */
                        )
                      )
                    ),
                  ]),
                  _c("yxt-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_kng_upload_lbl_down_allow" /** 单独设置允许下载 */
                        )
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm.permissionType === 1
                ? _c("auth-selector", {
                    staticClass: "mt10 ml24",
                    attrs: {
                      permissions: _vm.permissions,
                      disabled: _vm.disabled,
                      dataPermissionCode:
                        "kjgl_Download_permission_selection_range",
                    },
                    on: { update: _vm.update },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }